// helper for enabling feature flags
import { CURRENT_ENV } from 'env';
import { getClientBind } from 'store/APIClient';

const ENVIRONMENTS = {
    development: 'development',
    production: 'production',
    staging: 'staging',
    k8s: 'k8s',
    presentation: 'presentation',
    preprod: 'preprod',
} as const;

export const FEATURE_CHANGE_BUDGET_PHASE = 'change_budget_phase';
export const FEATURE_ORPHAN_INSCRIPTION = 'orphan_inscription';
export const FEATURE_MAINTENANCE = 'maintenance';
type FeatureT = {
    environments: string[];
    binds?: string[];
    excludeBinds?: string[];
};

const FEATURES: { [key: string]: FeatureT } = {
    [FEATURE_CHANGE_BUDGET_PHASE]: {
        environments: [
            ENVIRONMENTS.development,
            ENVIRONMENTS.staging,
            ENVIRONMENTS.k8s,
            ENVIRONMENTS.production,
            ENVIRONMENTS.presentation,
            ENVIRONMENTS.preprod,
        ],
        binds: [
            'customer-success', // also for customer succes
            'dashboards', // for customer success
            'demo-budget-1',
            'demo-budget-2',
            'demo-budget-3',
            'demo-budget-4',
            'demo-budget-5',
            'demo-budget-6',
            'demo-budget-7',
            'demo-budget-8',
            'demo-budget-9',
            'demo-budget-10',
            'demo-budget-cs-1',
            'demo-budget-sandbox',
            'demo-budget',
            'demo-sandbox',
            'demo-sifac',
            'demo', // for marketing team
            'elap',
            'ocii',
            'gig-budget',
            'sales-1',
            'sales-2',
            'sales-3',
            'sales-4',
            'sales-5',
            'sales-6',
            'sales-7',
            'sales-8',
            'sales-9',
            'sales-10',
        ],
    },

    [FEATURE_MAINTENANCE]: {
        environments: [],
    },
    [FEATURE_ORPHAN_INSCRIPTION]: {
        environments: [
            ENVIRONMENTS.development,
            ENVIRONMENTS.staging,
            ENVIRONMENTS.k8s,
            ENVIRONMENTS.production,
            ENVIRONMENTS.presentation,
            ENVIRONMENTS.preprod,
        ],
        excludeBinds: ['clamart'],
    },
};

export const isEnabled = (featureKey: string): boolean => {
    const feature = FEATURES[featureKey];
    if (!feature) return false;

    if (new URLSearchParams(window.location.search).get(featureKey))
        return true;

    const bind = getClientBind();

    if (feature.environments.includes(CURRENT_ENV)) {
        if (feature.binds !== undefined) {
            return feature.binds.includes(bind);
        }
        if (feature.excludeBinds !== undefined) {
            return !feature.excludeBinds.includes(bind);
        }
        return true;
    }

    return false;
};

export const disableChartConception = false;
